import { Box } from "@mui/material";
import Header from "../../components/shared/header/Header";
import HorizontalTabs from "../../components/shared/horizontal-tab";
import CreateProject from "../../components/executor/projects/CreateProject";
import { observer } from "mobx-react-lite";
import ActiveProjects from "../../components/executor/projects/ActiveProjects";
import ClosedProjects from "../../components/executor/projects/ClosedProjects";
import ExecutorSharedView from "../shared/ExecutorSharedView";

export default observer(function ManageProjects() {
  return (
    <ExecutorSharedView
      mainContent={
        <Box
          sx={{
            p: 2,
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header title="Projects Manager" />
          </Box>

          <HorizontalTabs
            tabNames={["active", "create", "Closed"]}
            tabContents={[
              <ActiveProjects />,
              <CreateProject />,
              <ClosedProjects />,
            ]}
          />
        </Box>
      }
    />
  );
});
